"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CookieBanner = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("b2b-components/theme/components/Button");
var _Icon = require("b2b-components/theme/components/Icon");
require("./CookieBanner.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var CookieBanner = function CookieBanner(_ref) {
  var onAccept = _ref.onAccept,
    defaultIsVisible = _ref.isVisible,
    text = _ref.text;
  var _useState = (0, _react.useState)(defaultIsVisible || false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  var handleAccept = function handleAccept() {
    onAccept === null || onAccept === void 0 ? void 0 : onAccept();
    setIsVisible(false);
  };

  // const handleReject = (): void => {
  //   onReject?.();
  //   setIsVisible(false);
  // };

  if (!isVisible) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-CookieBanner"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-CookieBanner-Container container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-CookieBanner-Icon"
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    name: _Icon.ICON_NAME.cookie
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-CookieBanner-MessageWrapper"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "cds-CookieBanner-Message",
    dangerouslySetInnerHTML: {
      __html: text.message
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cds-CookieBanner-ButtonsWrapper"
  }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    className: "cds-CookieBanner-Button cds-CookieBanner-Button--Accept",
    size: _Button.BUTTON_SIZE.small,
    onClick: handleAccept,
    styleType: _Button.BUTTON_STYLE_TYPE.primary
  }, text.acceptMessage))));
};
exports.CookieBanner = CookieBanner;